const headerTitle = {
  type: 'Label',
  name: '3',
  fontWeight: '700',
  letter: '0.14px',
  fontSize: '14px',
  lineHeight: '17.5px'
}

const desktopHeaderTitle = {
  type: 'Label',
  name: '6',
  fontWeight: '700',
  letter: '0.14px',
  fontSize: '16px',
  lineHeight: '20px'
}

const headerDescription = {
  type: 'Label',
  name: '1',
  fontWeight: '400',
  letter: '0.14px',
  fontSize: '14px',
  lineHeight: '17.5px',
  desktopFontSize: '14px',
  desktopLineHeight: '17.5px'
}

const contentDescription = {
  type: 'Paragraph',
  name: '4',
  fontWeight: '325',
  letter: 'normal',
  fontSize: '14px',
  lineHeight: '21px',
  desktopFontSize: '12px',
  desktopLineHeight: '15px'
}

const benefitCardTitle = {
  type: 'Label',
  name: '1',
  fontWeight: '700',
  letter: '0.14px',
  fontSize: '14px',
  lineHeight: '17.5px',
  desktopFontSize: '14px',
  desktopLineHeight: '17.5px'
}

const benefitCardDescription = {
  type: 'Paragraph',
  name: '3',
  fontWeight: '325',
  fontSize: '16px',
  lineHeight: '24px',
  desktopFontSize: '16px',
  desktopLineHeight: '24px'
}

export default {
  headerTitle,
  headerDescription,
  contentDescription,
  benefitCardTitle,
  benefitCardDescription,
  desktopHeaderTitle
}
